var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow/material-symbols:filter-list-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16667 15C8.93056 15 8.7325 14.92 8.5725 14.76C8.4125 14.6 8.33278 14.4022 8.33334 14.1667C8.33334 13.9306 8.41334 13.7325 8.57334 13.5725C8.73334 13.4125 8.93111 13.3328 9.16667 13.3333H10.8333C11.0694 13.3333 11.2675 13.4133 11.4275 13.5733C11.5875 13.7333 11.6672 13.9311 11.6667 14.1667C11.6667 14.4028 11.5867 14.6008 11.4267 14.7608C11.2667 14.9208 11.0689 15.0006 10.8333 15H9.16667ZM3.33334 6.66667C3.09723 6.66667 2.89917 6.58667 2.73917 6.42667C2.57917 6.26667 2.49945 6.06889 2.5 5.83334C2.5 5.59723 2.58 5.39917 2.74 5.23917C2.9 5.07917 3.09778 4.99945 3.33334 5H16.6667C16.9028 5 17.1008 5.08 17.2608 5.24C17.4208 5.4 17.5006 5.59778 17.5 5.83334C17.5 6.06945 17.42 6.2675 17.26 6.4275C17.1 6.5875 16.9022 6.66723 16.6667 6.66667H3.33334ZM5.83334 10.8333C5.59723 10.8333 5.39917 10.7533 5.23917 10.5933C5.07917 10.4333 4.99945 10.2356 5 10C5 9.76389 5.08 9.56584 5.24 9.40584C5.4 9.24584 5.59778 9.16611 5.83334 9.16667H14.1667C14.4028 9.16667 14.6008 9.24667 14.7608 9.40667C14.9208 9.56667 15.0006 9.76445 15 10C15 10.2361 14.92 10.4342 14.76 10.5942C14.6 10.7542 14.4022 10.8339 14.1667 10.8333H5.83334Z",
    fill: "#525259"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.21e129ea715291211eee4d21e14519a8.svg";
export { ForwardRef as ReactComponent };